module.exports = __webpack_public_path__ + "pic/68.65430bd8.png";